

import React, { useState } from "react"
const AnbargardaniLabel = (props) => {

    return (
        <React.Fragment>
            <div className="col">

                <div className="text-muted mx-1" title="ویرایش انبارگردانی" onClick={props.cleanAnbargardani} >
                     <span className="text-danger"> {props.anbargardani}</span>

                    :  انبارگردانی </div>
            </div>
        </React.Fragment>
    )
}
export default AnbargardaniLabel;

